// store/index.js
import { createStore } from 'vuex';
import moduleAuth from './moduleAuth';

export default createStore({
  modules: {
    auth: moduleAuth,
    // Ajoute d'autres modules ici si nécessaire
  }
});
